__turbopack_context__.v({
  "sponsorship_explanation": "fSHMQW_sponsorship_explanation",
  "sponsorship_explanation__link": "fSHMQW_sponsorship_explanation__link",
  "sponsorship_explanation__text": "fSHMQW_sponsorship_explanation__text",
  "sponsorship_mobile_explanation": "fSHMQW_sponsorship_mobile_explanation",
  "sponsorship_unit": "fSHMQW_sponsorship_unit",
  "sponsorship_unit__full_width": "fSHMQW_sponsorship_unit__full_width",
  "sponsorship_unit__in_flow": "fSHMQW_sponsorship_unit__in_flow",
  "sponsorship_unit__rendered": "fSHMQW_sponsorship_unit__rendered",
});
